<template>
  <el-dialog :title="title" :visible="visible" width="50%" @close="handleClose">
    <el-form label-width="120px" :model="editForm" ref="editForm">
      <el-row>
        <el-form-item label="客户名称" prop="customerName">
          <el-input
            size="small"
            v-model="editForm.customerName"
            auto-complete="off"
            placeholder="客户名称"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-form-item label="企业状态：" prop="status">
        <el-select size="small" v-model="editForm.status" placeholder="请选择">
          <el-option
            v-for="type in enterpriseType"
            :label="type.key"
            :value="type.value"
            :key="type.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="企业分类：">
        <el-select
          size="small"
          v-model="editForm.customerType"
          placeholder="请选择"
        >
          <el-option
            v-for="type in enterpriseCategoryType"
            :label="type.key"
            :value="type.value"
            :key="type.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-row>
        <el-form-item>
          <el-button size="small" type="primary" @click="handleSubmit"
            >确定</el-button
          >
          <el-button size="small" @click="handleClose">返回</el-button>
        </el-form-item>
      </el-row>
    </el-form>
  </el-dialog>
</template>

<script>
import {saveClient } from "@/api/ticket/client";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    editForm: {
      type: Object,
      default: () => ({}),
    },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      enterpriseType: [
        { key: "空", value: "" },
        { key: "正常", value: "正常" },
        { key: "异常", value: "异常" },
      ],
      enterpriseCategoryType: [
        { key: "空", value: "" },
        { key: "企业", value: "企业" },
        { key: "银行", value: "银行" },
      ],
    };
  },
  methods: {
    handleSubmit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          let method;
          if (this.editForm.id) {
            method = updateClient;
          } else {
            method = saveClient;
          }
          method(this.editForm)
            .then(() => {
              this.$message({
                message: `${this.editForm.id ? "编辑" : "保存"}成功`,
                type: "success",
              });
              this.$emit("confirm");
              this.handleClose();
            })
            .catch((err) => {
              this.$message({
                message: err.message,
                type: "error",
              });
            });
        }
      });
    },
    handleClose() {
      this.$emit("update:visible", false);
      this.$refs.editForm.resetFields();
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/customer/potential/add-edit/index.vue